export default __webpack_public_path__ + "assets/Luxury.149cf208.png";